export default __webpack_public_path__ + "static/media/CosmosLogo.92d73fe6.svg";